import { render, staticRenderFns } from "./MemberTagging.vue?vue&type=template&id=6cea0329"
import script from "./MemberTagging.vue?vue&type=script&lang=js"
export * from "./MemberTagging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports